import React from "react";

import BusinessIcon from "@mui/icons-material/BusinessOutlined";

import ListDetailView, { ListViewItem, withListDetail } from "../components/ListDetailView";
import { useSideSheet } from "../components/SideSheet";
import { useUserInfo } from "../utils/security";

export const CounterpartiesIcon = BusinessIcon;

const ListItem = ({ data, ...props }) => {
    return <ListViewItem {...props} mainText="Pilsner Urquell" />;
};

const CounterpartiesPage = withListDetail(() => {
    const sideSheet = useSideSheet();
    const { userInfo } = useUserInfo();

    return (
        <>
            <ListDetailView title="Protistrany" renderItem={(props) => <ListItem {...props} />} />
        </>
    );
});

export default CounterpartiesPage;
